import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import AOS from "aos";
import "aos/dist/aos.css";
import "./AboutUs.css";

import aboutImg from "../assets/slide2.png"; // Replace with your best About Us image

const AboutUs = () => {
  const navigate = useNavigate();

  useEffect(() => {
    AOS.init({ duration: 1000, once: true, easing: "ease-out-cubic" });
  }, []);

  return (
    <section className="aboutus-section-home" id="aboutus-home" data-aos="fade-up">
      <div className="aboutus-container-home">
        
        {/* Left: Image */}
        <div className="aboutus-image-home" data-aos="fade-up" data-aos-delay="100">
          <img src={aboutImg} alt="About Development Education and Welfare Trust" />
        </div>

        {/* Right: Content */}
        <div className="aboutus-content-home">
          <h2 className="aboutus-title-home">
            About <span>Us</span>
          </h2>
          <p className="aboutus-description-home">
            The <strong>Development Education and Welfare Trust</strong> was founded in 2000 
            by <strong>Mr. Lucas Thapa</strong>, Chairman of the organization. Registered as a subordinate 
            NGO (Trust) of West Bengal under registration number <strong>IV/93/2000</strong>, the trust is 
            built on the philosophy of driving <em>social, cultural, economic, and educational change</em> 
            for holistic transformation in society through education.  
            <br /><br />
            From its very beginning, the Trust has campaigned to bring positive change in communities by 
            addressing key social issues. This continuous effort has inspired many individuals and continues 
            to impact lives meaningfully.
          </p>

          {/* Stats */}
          <div className="aboutus-stats-home">
            <div className="aboutus-stat-card-home" data-aos="fade-up" data-aos-delay="100">
              <h3>500+</h3>
              <p>Communities Supported</p>
            </div>
            <div className="aboutus-stat-card-home" data-aos="fade-up" data-aos-delay="200">
              <h3>1,000+</h3>
              <p>Lives Impacted</p>
            </div>
            <div className="aboutus-stat-card-home" data-aos="fade-up" data-aos-delay="300">
              <h3>5+</h3>
              <p>Years of Service</p>
            </div>
          </div>

          {/* CTA */}
          <div className="aboutus-cta-home" data-aos="fade-up" data-aos-delay="400">
            <button
              className="aboutus-btn-home"
              onClick={() => navigate("/about")}
            >
              Learn More
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutUs;
